import React from 'react';
import InvoiceHeader from './InvoiceHeader';
import TotalAmount from './TotalAmount';
import { ReviewOrderStyle } from '../../pages/order/Review';
import InvoiceFooter from './InvoiceFooter';
import { printType } from '../../constants/orderStatus';
import AdditionalChargeList from './AdditionalChargeList';

const CLIENT = process.env.REACT_APP_CLIENT || 'woodworth';

const InvoiceToPrint = React.forwardRef(
  ({ order, type = printType.INVOICE }, ref) => (
    <div className="invoice-container" ref={ref}>
      <div className="invoice-content">
        <InvoiceHeader order={order} type={type} />
        <div style={{ marginTop: '30px' }} />
        <div className="order-product-items">
          {order?.orderstyles?.map(orderStyle => (
            <ReviewOrderStyle key={orderStyle.id} orderStyle={orderStyle} />
          ))}
        </div>
        {order?.orderadditionalcharges?.length > 0 && (
          <AdditionalChargeList
            orderAdditionalCharges={order.orderadditionalcharges}
          />
        )}
        <div className="invoice-content-footer-area">
          <InvoiceFooter type={type} />
          <TotalAmount order={order} />
        </div>
        {type === printType.INVOICE &&
          CLIENT === 'woodworth' &&
          !order?.memoOrder && (
            <div style={{ marginTop: '20px' }}>
              <h4 style={{ textAlign: 'center' }}>GST/HST No. 750447492</h4>
            </div>
          )}
      </div>
    </div>
  ),
);

export default InvoiceToPrint;
